import { ArrowForward } from '@mui/icons-material';
import { Button, Card, CardActions, CardContent, CardHeader, Divider, Grid, Grid2, Typography } from '@mui/material';
import React from 'react';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';

function Home() {
    const navigate = useNavigate(); // Initialize the navigate function

    const DaftarAction = () => {
        navigate('/daftar');
    };

    const LoginAction = () => {
        navigate('/login');
    };

    return (
        <>
            <Grid sx={{ padding: "10px" }} spacing={2} container>
                <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Card>
                        <CardHeader title="Selamat Datang" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                        </CardHeader>
                        <CardContent>
                            <Typography variant="h6" component="div" sx={{ mb: 2 }}>
                                Selamat datang di Applikasi Pendaftaran Santri Baru di Baladil Huffadz Bandung.
                            </Typography>
                            <Typography component="div" variant='h7' sx={{ mb: 2 }}>
                                Sebelum mendaftar, pastikan Anda telah membaca mekanisme dan tahapan pendaftaran terlebih dahulu. Kemudian, pilih jenjang di samping yang sesuai.
                            </Typography>
                            <Typography component="div" variant='h7' sx={{ mb: 2 }}>
                                Demi kenyamanan dan kelancaran di dalam pengisian formulir pendaftaran, maka kami sarankan untuk menggunakan komputer atau laptop.
                            </Typography>
                            <Grid2 container columns={24} spacing={2}>
                                <Grid2 size={12}>
                                    <Button onClick={() => {
                                        DaftarAction();
                                    }} fullWidth sx={{ padding: "20px", backgroundColor: '#e96726' }} variant='contained' startIcon={<BorderColorIcon></BorderColorIcon>}>
                                        Daftar
                                    </Button>
                                    <Typography variant='caption'>
                                        Pendaftaran calon santri baru
                                    </Typography>
                                </Grid2>
                                <Grid2 size={12}>
                                    <Button onClick={() => {
                                        LoginAction();
                                    }} fullWidth sx={{ padding: "20px", backgroundColor: '#e96726' }} variant='contained' startIcon={<LoginIcon></LoginIcon>}>Login</Button>
                                    <Typography variant='caption'>
                                        Download / Upload Berkas, Ubah Data, Lihat Pengumuman, dll
                                    </Typography>
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Card>
                        <CardHeader title="Daftar Program" sx={{ borderBottom: "1px solid #f4f4f4" }}></CardHeader>
                        <CardContent>
                            <Grid sx={{ padding: "10px" }} container spacing={2}>
                                <Grid sx={{ padding: "5px" }} xs={12} md={6} sm={12} lg={6} xl={6}>
                                    <Card sx={{ backgroundColor: "#00c0ef", color: "#FFFFFF" }}>
                                        <CardContent>
                                            <Typography variant='h4'>
                                                SD Sulaiman
                                            </Typography>
                                        </CardContent>
                                        <Divider></Divider>
                                        <CardActions>
                                            <Button href='/daftar/SD' size="small" color="ligth" endIcon={<ArrowForward></ArrowForward>}>
                                                Daftar
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid sx={{ padding: "5px" }} xs={12} md={6} sm={12} lg={6} xl={6}>
                                    <Card sx={{ backgroundColor: "#00a65a", color: "#FFFFFF" }}>
                                        <CardContent>
                                            <Typography variant='h4'>
                                                TK
                                            </Typography>
                                        </CardContent>
                                        <Divider></Divider>
                                        <CardActions>
                                            <Button href='/daftar/TKQ' size="small" color="ligth" endIcon={<ArrowForward></ArrowForward>}>
                                                Daftar
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid sx={{ padding: "5px" }} xs={12} md={6} sm={12} lg={6} xl={6}>
                                    <Card sx={{ backgroundColor: "#f39c12", color: "#FFFFFF" }}>
                                        <CardContent>
                                            <Typography variant='h4'>
                                                PAUD LQ
                                            </Typography>
                                        </CardContent>
                                        <Divider></Divider>
                                        <CardActions>
                                            <Button href='/daftar/PAUDLQ' size="small" color="ligth" endIcon={<ArrowForward></ArrowForward>}>
                                                Daftar
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid sx={{ padding: "5px" }} xs={12} md={6} sm={12} lg={6} xl={6}>
                                    <Card sx={{ backgroundColor: "#EA7043", color: "#FFFFFF" }}>
                                        <CardContent>
                                            <Typography variant='h4'>
                                                PAUD Q
                                            </Typography>
                                        </CardContent>
                                        <Divider></Divider>
                                        <CardActions>
                                            <Button href='/daftar/PAUDQ' size="small" color="ligth" endIcon={<ArrowForward></ArrowForward>}>
                                                Daftar
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid>

                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}

export default Home;